


















































































import { Vue, Component } from 'vue-property-decorator';
import AddressCard from '@/project/ui-components/address/AddressCard.vue';
import OrderLineBlock from '@/project/ui-components/order/OrderLineBlock.vue';
import OrderSummary from '@/project/ui-components/order/OrderSummary.vue';
import ConfirmationProcessBlock from './ConfirmationProcessBlock.vue';
import ConfirmationPageOrderInformation from './ConfirmationPageOrderInformation.vue';
import SpinnerOverlay from '@/project/spinners/SpinnerOverlay.vue';
import Api from '@/project/http/Api.service';
import { AddressViewObject, ReceiptLineItemViewObject, ReceiptViewModel, ReceiptQuoteViewObject } from '@/types/apiServerContract';
import authService from '@/core/auth/auth.service';
import logService from '@/core/logging.service';
import tokenService from '@/core/auth/token.service';
import PageToaster from '@/project/ui-components/PageToaster.vue';
import gtmService from '@/project/tracking/gtm/GTM.service';
import { PageName } from '@/router/routes/constants';
import { BaseContentModel, JsonContent } from '@/types/contentServerContract';
import serverContext from '@/core/serverContext.service';
import contentApiService from '@/core/http/contentApi.service';
import PrintService from '@/core/print/print.service';

@Component({
    components: { ConfirmationProcessBlock, ConfirmationPageOrderInformation, AddressCard, OrderLineBlock, OrderSummary, SpinnerOverlay, PageToaster }
})
export default class ConfirmationPage extends Vue {
    private receiptModel: ReceiptViewModel | null = null;
    private invoiceAddress: AddressViewObject | null = null;
    private deliveryAddress: AddressViewObject | null = null;
    private lineItems: ReceiptLineItemViewObject[] = [];
    private quotes: ReceiptQuoteViewObject[] | null = null;
    private dataLoaded: boolean = false;
    private priceNotAvailable: boolean = false;
    private invalidOrderId = false;
    private pageBlocks: JsonContent[] | null = null;

    private get myAccountHistoryPage() {
        return PageName.MY_ACCOUNT_ORDER_HISTORY;
    }

    private get lineItemsWithoutQuote() {
        return this.lineItems.filter(x => !x.quoteId);
    }

    private async fetchReceipt(id: string) {
        try {
            const receiptViewModel = await Api.checkout.receipt(id);

            this.invoiceAddress = receiptViewModel.invoiceAddress;
            this.deliveryAddress = receiptViewModel.deliveryAddress;
            this.lineItems = receiptViewModel.lineItems;
            this.quotes = receiptViewModel.quotes;

            this.receiptModel = receiptViewModel;
            if (!this.hasBeenTracked(id)) {
                this.trackPage(id, receiptViewModel);
            }
        } catch (error) {
            if (error.status === 400) {
                this.invalidOrderId = true;
            }

            logService.error(error);
        } finally {
            this.dataLoaded = true;
        }
    }

    private hasBeenTracked(orderId: string): boolean {
        const cookie = document.cookie;
        return cookie.includes(this.pageTrackedCookieName(orderId));
    }

    private pageTrackedCookieName(orderId: string): string {
        return `eet-confirmation-${orderId}`;
    }

    private trackPage(orderId: string, receiptViewModel: ReceiptViewModel) {
        gtmService.trackConfirmationPage(orderId, receiptViewModel);
        const timeoutSecs = 60 * 60 * 24 * 30; // 1 month
        document.cookie = `${this.pageTrackedCookieName(orderId)}=true;max-age=${timeoutSecs}`;
    }

    private get userData() {
        return tokenService.getUserData();
    }

    private async getPageData() {
        const pageUrl = `${serverContext?.settings?.receiptPage || window.servercontext?.siteChrome?.settings?.receiptPage || ''}`;
        try {
            const result = await contentApiService.getContent<BaseContentModel>(pageUrl);
            this.pageBlocks = result.blocks;
        } catch {
            // No content - ignored
        }
    }

    private created() {
        const orderId: string = location.search.split('=')[1];

        if (authService.isLoggedIn()) {
            this.fetchReceipt(orderId);
            this.getPageData();
        }
    }

    private print() {
        return PrintService.print(this.$el);
    }
}
